import { DESKTOP_NAV_DROPDOWN_CLOSE_DELAY, DESKTOP_NAV_DROPDOWN_OPEN_DELAY } from '../../../../constants/navigation'
import { createContext, useContext, useState, useMemo, useCallback } from 'react'
import { useTheme } from '@homebotapp/hb-react-component-catalog'

interface DropdownContextInterface {
  setIsOpen: (arg) => void
  open: boolean
  isLightThemeType: boolean
}

const DropdownContext = createContext<DropdownContextInterface | null>(null)

const DropdownProvider = ({ children }) => {
  const {
    theme: { isLightThemeType }
  } = useTheme()
  const [open, setOpen] = useState(false)

  const setIsOpen = useCallback(isOpen => {
    if (isOpen) {
      setTimeout(() => {
        setOpen(true)
      }, DESKTOP_NAV_DROPDOWN_OPEN_DELAY)
    } else {
      setTimeout(() => {
        setOpen(false)
      }, DESKTOP_NAV_DROPDOWN_CLOSE_DELAY)
    }
  }, [])

  const value = useMemo(
    () => ({
      isLightThemeType,
      open,
      setIsOpen
    }),
    [isLightThemeType, open, setIsOpen]
  )

  return <DropdownContext.Provider value={value}>{children}</DropdownContext.Provider>
}

const useDropdownContext = () => {
  const context = useContext(DropdownContext)

  if (!context) {
    throw new Error('useDropdownContext must be used within an Dropdown Provider')
  }

  return { ...context }
}

export { DropdownProvider, useDropdownContext }
